'use client';

export { default } from './Menu';
export { default as menuClasses } from './menuClasses';
export * from './menuClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Menu/index.js
// module id = 862
// module chunks = 22